<template>
<div class="container forgot">

    <!-- Outer Row -->
    <div class="row justify-content-center">

        <div class="col-xl-10 col-lg-12 col-md-9">

            <div class="card o-hidden border-0 shadow-lg my-5">
                <div class="card-body p-0">
                    <!-- Nested Row within Card Body -->
                    <div class="row">
                        <div class="col-lg-6 bg-login-image bg-primary">
                            <h1 style="font-weight:bold" class="h1 text-bold text-white mb-4">PLANET</h1>
                        </div>
                        <div class="col-lg-6">
                            <div class="p-5">
                                <div class="text-center">
                                    <h1 class="h4 text-gray-900 mb-2">Forgot Your Password?</h1>
                                    <p class="mb-4">We get it, stuff happens. Just enter your email address below and we'll send you a link to reset your password!</p>
                                </div>
                                <div v-if="error" class="alert alert-danger">{{error}}</div>
                                <div v-if="success" class="alert alert-success">{{success}}</div>
                                <form class="user" v-if="!success" @submit.prevent="forgot()">
                                    <div class="form-group">
                                        <input type="email" required class="form-control form-control-user" v-model="email" id="email" name="email" aria-describedby="emailHelp" placeholder="Enter Email Address...">
                                    </div>
                                    <button type="submit" class="btn btn-primary btn-user btn-block">
                                        Reset Password
                                    </button>
                                </form>
                                <hr>
                                <!--<div class="text-center">
                    <a class="small" href="register.html">Create an Account!</a>
                  </div>-->
                                <div class="text-center">
                                    <router-link class="small" to="/login">Go Back to Login</router-link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>

    </div>

</div>
</template>

<script>
import {
    firebaseAuth
} from "../main";

export default {
    name: 'Forgot',
    data: function () {
        return {
            email: '',
            error: null,
            success: null,
        }
    },
    methods: {
        forgot() {
            console.log(this.email);
            this.error = null;
            firebaseAuth().sendPasswordResetEmail(this.email).then(() => {
                this.success = "Forgot password request submitted successful, please check you email for further details"
            }).catch((err) => {
                this.error = err.message;
            })
        }
    }
}
</script>
